import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthorizationService } from '@modules/authorization/services/authorization.service';
import { StorageKeys } from '@modules/storage/storage.enum';
import { map } from 'rxjs/operators';
import { Storage } from '@modules/storage/storage.service';
import { DefaultService } from '@codegen/service';
import { GetUserBotRedirectResponse } from '@codegen';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const storage = inject(Storage);
  const botService = inject(DefaultService);
  const auth = inject(AuthorizationService);

  const isLinkFromBot: boolean = storage.isValue(StorageKeys.Bot);

  if (auth.isAuthorized()) {
    if (isLinkFromBot) {
      return botService
        .informationUserBotRedirectUrl({
          bot: storage.getItem(StorageKeys.Bot),
        })
        .pipe(
          map((data: GetUserBotRedirectResponse) => {
            if (data.errorInfo.error === '0') {
              storage.removeItem(StorageKeys.Bot);
              window.location.href = data.redirectUrl;
              return true;
            } else {
              storage.removeItem(StorageKeys.Bot);
              return true;
            }
          })
        );
    }
    return true;
  }

  if (isLinkFromBot) {
    return router.navigateByUrl('/auth').then(() => false);
  }

  router.navigate(['']);
  return false;
};
